module.exports = __webpack_public_path__ + "static/Service-hero-cfac32fee9ffb678aa7cfe804079f18b.jpg";